'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Benefits = exports.BenefitsUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nukaCarousel = require('nuka-carousel');

var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);

var _multitrack = require('helpers/multitrack');

var _verify = require('helpers/verify');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _Media = require('decorators/Media/Media');

var _Media2 = _interopRequireDefault(_Media);

var _Controls = require('../../../Carousel/Controls');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BenefitsUnwrapped = exports.BenefitsUnwrapped = function (_Component) {
  (0, _inherits3.default)(BenefitsUnwrapped, _Component);

  function BenefitsUnwrapped() {
    (0, _classCallCheck3.default)(this, BenefitsUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (BenefitsUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(BenefitsUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(BenefitsUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('Benefits Module', 'Viewed benefits module', '', 0, { nonInteraction: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var content = void 0;
      var _props = this.props,
          mediaQueryMd = _props.mediaQueryMd,
          backgroundColor = _props.backgroundColor,
          title = _props.title,
          benefits = _props.benefits;


      if ((0, _verify.isEmpty)(benefits)) {
        return null;
      }

      if (mediaQueryMd) {
        content = _react2.default.createElement(
          'ul',
          null,
          benefits.map(function (benefit) {
            return _react2.default.createElement(
              'li',
              { key: benefit.title, className: 'pricing-benefits__item' },
              _react2.default.createElement(
                'h3',
                null,
                benefit.title
              ),
              _react2.default.createElement(
                'p',
                null,
                benefit.description
              )
            );
          })
        );
      } else {
        content = _react2.default.createElement(
          _nukaCarousel2.default,
          {
            decorators: [{
              component: _Controls.Pagination,
              position: 'BottomCenter'
            }],
            className: 'carousel--benefits',
            cellAlign: 'left',
            edgeEasing: 'easeOut',
            speed: 150,
            slidesToShow: 1,
            slidesToScroll: 1
          },
          _react2.default.createElement(
            'span',
            null,
            benefits.slice(0, 3).map(function (benefit) {
              return _react2.default.createElement(
                'div',
                { key: benefit.title, className: 'pricing-benefits__item' },
                _react2.default.createElement(
                  'h3',
                  null,
                  benefit.title
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  benefit.description
                )
              );
            })
          ),
          _react2.default.createElement(
            'span',
            null,
            benefits.slice(3, 6).map(function (benefit) {
              return _react2.default.createElement(
                'div',
                { key: benefit.title, className: 'pricing-benefits__item' },
                _react2.default.createElement(
                  'h3',
                  null,
                  benefit.title
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  benefit.description
                )
              );
            })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'bg--' + (backgroundColor || 'white') },
        _react2.default.createElement(
          'div',
          { className: 'pricing-benefits' },
          _react2.default.createElement(
            'h2',
            { className: 'gamma' },
            title
          ),
          content
        )
      );
    }
  }]);
  return BenefitsUnwrapped;
}(_react.Component);

BenefitsUnwrapped.propTypes = {
  mediaQueryMd: _propTypes2.default.bool,
  backgroundColor: _propTypes2.default.oneOf(['white', 'light']),
  benefits: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string,
    description: _propTypes2.default.string,
    type: _propTypes2.default.string
  })),
  title: _propTypes2.default.string
};

BenefitsUnwrapped.propMapper = function (state, moduleDef) {
  if (!moduleDef.information) {
    // eslint-disable-next-line no-console
    console.error('Benefits information missing for ' + moduleDef.moduleName + ': ' + (0, _stringify2.default)(moduleDef));
  }

  return {
    title: moduleDef.title,
    benefits: moduleDef.information || []
  };
};

var Benefits = exports.Benefits = (0, _Media2.default)((0, _TrackDwell2.default)(BenefitsUnwrapped));